import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from 'components';
import WebQrForm from '../components/WebQrForm';
import useWebQrs from '../useWebQrs';

const WebQrEdit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  const {
    form,
    singleItem,
    loading,
    updateInProcess,
    shoppingCenters,
    loadingCompanies,
    handleCreateOrUpdate,
  } = useWebQrs();

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  return (
    <>
      <PageHeader
        title={isEdit ? t('Modifica QR Code') : t('Crea Nuovo QR Code')}
      />
      
      <WebQrForm
        form={form}
        onFinish={onFinish}
        loading={loading}
        updateInProcess={updateInProcess}
        shoppingCenters={shoppingCenters}
        loadingCompanies={loadingCompanies}
        singleItem={singleItem}
        isEdit={isEdit}
      />
    </>
  );
};

export default WebQrEdit;
